import _ from 'lodash';
import GridSection from '../common/GridSectionNew';
import { ADMIN_MY_PRODUCTS_UPLOADS, MY_PRODUCTS_ROUTE } from '../constants/routePathConstants';
import MyProductsTextures from './MyProductsTextures';
import { useUploads } from '../hooks/useTextures';
import { MODEL_TYPES, TEXTURE_FILTER_TYPE } from '../constants/constants';
import { useFilterDropdownOptions } from '../hooks/useFilterDropdownOptions';
import { getFiltersApi } from '../api/commonApi';
import { useDispatch } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { UPLOAD_MAP_FILTER_ID } from '../config/constant/curatorConstants';
import { useFilterData } from '../hooks/useFilterData';
import { setLables } from '../redux/slicers/admin/sidebarSlicer';
import { useUserContext } from '../contexts/UserContext';
import { useFetchAllFilters } from '../hooks/useFetchAllFilters';
import { MxEvent } from '../common/Mixpanel';

const MyProductsUploads = ({
  cardType = 'uploads',
  carouselView,
  title,
  useGlobalSearch,
  noDataText,
  modelType = MODEL_TYPES.UPLOADS,
  cardProps,
  hideBreadcrumbs,
  designV2,
  hideStickyHeader = null
}) => {
  const { currentUser } = useUserContext();
  const dispatch = useDispatch();

  const breadcrumbs = [
    {
      link: MY_PRODUCTS_ROUTE,
      label: 'My products',
      mx_event: MxEvent.VISITED_MY_PRODUCTS,
    },
    {
      label: `Custom Maps`,
    },
  ];
 
  const requestParams = useMemo(
    () => ({
      created_by: '', //currentUser.id,
      is_map: true,
    }),
    [currentUser.id]
  );

  // commenting this as we get all filters from API
  // handle filters
  // const { filter: uploadFilter } = useFilterData({ filterId: UPLOAD_MAP_FILTER_ID });
  // useEffect(() => {
  //   // add filter to sidebar
  //   if (!uploadFilter?.id) return;
  //   const { id, label_name, options } = uploadFilter;
  //   const sidefilter = {};
  //   sidefilter.filterlabels = [{ id, label_name, order: 0 }];
  //   sidefilter.filteroptions = options;
  //   dispatch(setLables({ sidefilter, maxVisible: 100 }));
  // }, [uploadFilter]);

  if (carouselView) {
    return <CarouselView title={title} requestParams={requestParams} />;
  }

  return (
    <MyProductsTextures
      hideStickyHeader={hideStickyHeader}
      designV2={designV2}
      cardType={cardType}
      breadcrumbs={hideBreadcrumbs ? [] : breadcrumbs}
      title="Custom Maps"
      pageTitle="Custom Maps"
      type="uploads"
      useGlobalSearch={useGlobalSearch}
      noDataText={noDataText}
      modelType={modelType}
      cardProps={cardProps}
      membersFilterDefaultSelected="" // "me"
      apiConfig={{
        requestParams,
      }}
    />
  );
};

const CarouselView = ({ title, requestParams }) => {
  const { list, loading, total, refetchList } = useUploads({
    requestParams,
  });

  return (
    <>
      {list.length > 0 && (
        <GridSection
          title={title}
          itemsTotal={total}
          seeAllLink={ADMIN_MY_PRODUCTS_UPLOADS}
          carouselData={list}
          modelType={MODEL_TYPES.UPLOADS}
          loading={loading}
          emptyDisplay={<h4>Find curator maps here.</h4>}
          onSuccess={refetchList}
          mx_event={MxEvent.VISITED_MY_CUSTOM_MAPS}
        />
      )}
    </>
  );
};

export default MyProductsUploads;
